import { Link } from "@StarberryUtils";
import * as React from "react"
import { Button, Container, Row, Col, Accordion, Card, useAccordionToggle } from "react-bootstrap"
//import ScrollAnimation from "react-animate-on-scroll";
import HTMLReactParser from 'html-react-parser';
import { useStaticQuery, graphql } from "gatsby";
import Slider from "react-slick";
import { useContext } from "react"
import AccordionContext from "react-bootstrap/AccordionContext"
import "./Information.scss"

// markup
const Information = () => {

    const data = useStaticQuery(graphql`
    query {
      glstrapi {
	    globalModule {
            Useful_Information 
	    }
      }
    }
  `);

    const content = data.glstrapi.globalModule

    return (
        <React.Fragment>
            <section className="usefull-information">
                <div animateIn='fadeInUp' animateOut='fadeOut'>
                    <div className="info d-xl-block">
                        <h2>Useful Information</h2>
                        {HTMLReactParser(content.Useful_Information.replace(/\n/g, '<br />'))}
                    </div>
                </div>
            </section>
        </React.Fragment>
    )
}
export default Information